import React from "react";
import {List, Map} from "immutable";
import {cx, addClassName} from "../lib/ClassSet";
import "./Table.scss";
import Loading from "./Loading";

const Table = (props) => {
  const {
    loading, data = new Map(),
    renderer, rendererParams,
    itemKey, selected, getItemKey, getIsSelected,
  } = props;

  let getKeyFn = (item) => item.get(itemKey);
  if (getItemKey) {
    getKeyFn = getItemKey;
  }

  // let isSelectedFn = (item) => item.get(itemKey) === selected;
  let isSelectedFn = (item) => getKeyFn(item) === selected;
  if (getIsSelected) {
    isSelectedFn = getIsSelected;
  }

  const items = data.map((item) => {
    return React.createElement(renderer, {
      data: item, 
      key: getKeyFn(item),
      getKeyFn: getKeyFn,
      selected: isSelectedFn(item),
      onClick: props.onItemClick,
      onCommand: props.onCommand,
      onContextMenuClick: props.onContextMenuClick,
      ...rendererParams
    });
  }).toList();

  let classes = cx({
    "Table": true,
    "mode-list": props.mode === "list",
    "mode-table": props.mode === "table"
  })

  classes = addClassName(props.extraClassName !== "", classes, props.extraClassName);

  let countElement = null;
  if (props.showCount) {
    countElement = <div className="table-count">{items.size} rows</div>
  }

  let tableHeader = null;

  if (props.mode === "list") {
    if (props.tableHeader.size > 0) {
      tableHeader = (
        <li className="header">
          { props.tableHeader.map((h, i) => <div key={i}>{h}</div>) }
        </li>
      );
    }

    return (
      <div className={classes}>
        <ul>
          {tableHeader}
          {items}
        </ul>
        {loading && <Loading />}
        {countElement}
      </div>
    )
  }

  if (props.tableHeader.size > 0) {
    const ths = props.tableHeader.map((v,i) => genTableHeaderItem(v, i, props.createSortingArrows));
    let filtersRow = null;
    if (props.createFilteringInput) {
      const filters = props.tableHeader.map(
        (v,i) => genTableHeaderFilterItem(v, i, props.createFilteringInput)
      );

      filtersRow = filters && (
        <tr className="filters">{ filters }</tr>
      );
    }

    tableHeader = (
      <thead>
        <tr>
          {ths}
        </tr>
        { filtersRow }
      </thead>
    );
  }

  return (
    <div className={classes}>
      <table>
        {tableHeader}
        <tbody>
          {items}
        </tbody>
      </table>
      {loading && <Loading />}
      {countElement}
    </div>
  );
}

function genTableHeaderItem(value, i, createSortingArrows) {
  if (Map.isMap(value)) {
    const id = value.get("id", "");
    const arrows = id && createSortingArrows && createSortingArrows(id);
    return <td key={`row-${i}`} className={`f-${id}`}>{value.get("title", "")} {arrows}</td>
  }
  return <td key={`row-${i}`}>{value}</td>
}
function genTableHeaderFilterItem(value, i, createFilteringInput) {
  if (Map.isMap(value)) {
    const id = value.get("id", "");
    return <td key={`row-${i}`} className={`f-${id}`}>{createFilteringInput(id)}</td>
  }
  return <td key={`row-${i}`}></td>
}


export default Table;


Table.defaultProps = {
  itemKey: "id",
  extraClassName: "",
  tableHeader: List([]),
  rendererParams: {},
  mode: "list",
  showCount: false
}